import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "primary";
  children: ReactNode;
}

export function Button({ variant = "default", children, className, ...rest }: ButtonProps) {
  return (
    <button
      className={`bios-button ${variant === "primary" ? "primary" : ""} ${className ?? ""}`}
      {...rest}
    >
      {children}
    </button>
  );
}
